import { z } from 'zod';

import { UserRole, UserStatus } from '../enums.js';

import { Ulid } from './common.js';

export const User = z.object({
  id: Ulid,
  email: z.string().email(),
  fullName: z.string().min(1).max(120),
  avatarUrl: z.string().url().nullable(),
  role: UserRole,
  status: UserStatus,
  mfaEnabled: z.boolean(),
  lastLoginAt: z.string().datetime().nullable(),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
});
export type User = z.infer<typeof User>;

/** Public-safe view of a user (no MFA fields, no audit fields). */
export const UserPublic = User.pick({
  id: true,
  email: true,
  fullName: true,
  avatarUrl: true,
  role: true,
  status: true,
});
export type UserPublic = z.infer<typeof UserPublic>;

export const UserCreate = z.object({
  email: z.string().email(),
  fullName: z.string().min(1).max(120),
  role: UserRole.exclude(['MASTER']).default('MEMBER'),
  starterProjectId: Ulid.optional(),
  starterProjectRole: z.enum(['manager', 'member', 'viewer']).optional(),
});
export type UserCreate = z.infer<typeof UserCreate>;

export const UserUpdate = z
  .object({
    fullName: z.string().min(1).max(120),
    avatarUrl: z.string().url().nullable(),
    role: UserRole,
    status: UserStatus,
  })
  .partial();
export type UserUpdate = z.infer<typeof UserUpdate>;

export const UserActivation = z.object({
  token: z.string().min(20),
  password: z.string().min(12).max(128),
});
export type UserActivation = z.infer<typeof UserActivation>;
